/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import adapterIntegrationApi from '../../../api/adapterIntegration.api';

/* Thunks */
export const getSubmissionByApplicationNumber = async ({ applicationNumber, protectionSelection }) => {
  const autofillFields = await adapterIntegrationApi.getByApplicationNumber(applicationNumber, protectionSelection);
  return autofillFields;
};

export const getSubmissionByPublicationNumber = async ({ publicationNumber, protectionSelection }) => {
  const autofillFields = await adapterIntegrationApi.getByPublicationNumber(publicationNumber, protectionSelection);
  return autofillFields;
};

export const findSubmissionByApplicationNumber = createFOAsyncThunk(
  'autofill/findSubmissionByApplicationNumber',
  async ({ applicationNumber, protectionSelection }) => {
    const fields = await getSubmissionByApplicationNumber({ applicationNumber, protectionSelection });
    return fields;
  },
);

export const findSubmissionByPublicationNumber = createFOAsyncThunk(
  'autofill/findSubmissionByPublicationNumber',
  async ({ publicationNumber, protectionSelection }) => {
    const fields = await getSubmissionByPublicationNumber({ publicationNumber, protectionSelection });
    return fields;
  },
);
